import React from "react";
import { HiSpeakerWave } from "react-icons/hi2";
import { Tooltip } from "./Tooltip";

interface VolumeSliderProps {
  volume: number;
  onVolumeChange: (newVolume: number) => void;
}

export const VolumeSlider: React.FC<VolumeSliderProps> = ({
  volume,
  onVolumeChange,
}) => {
  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    onVolumeChange(newVolume);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0,
        width: "100%",
        maxWidth: "100%",
        paddingTop: 0,
        paddingBottom: 0,
        flex: 1,
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "20px",
        }}
      >
        {/* Speaker Icon */}
        <Tooltip text="Volume" position="top">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "24px",
              height: "24px",
              color: "var(--icon-color)",
            }}
          >
            {HiSpeakerWave({
              size: 20,
              style: { filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))" },
            })}
          </div>
        </Tooltip>

        {/* Volume Slider */}
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={handleSliderChange}
          style={{
            flex: 1,
            height: "4px",
            borderRadius: "3px",
            background: `linear-gradient(to right, var(--slider-track) 0%, var(--slider-track) ${
              volume * 100
            }%, var(--slider-thumb) ${
              volume * 100
            }%, var(--slider-thumb) 100%)`,
            outline: "none",
            cursor: "pointer",
            WebkitAppearance: "none",
            appearance: "none",
          }}
          onMouseDown={(e) => {
            const slider = e.currentTarget;
            slider.style.cursor = "grabbing";
          }}
          onMouseUp={(e) => {
            const slider = e.currentTarget;
            slider.style.cursor = "pointer";
          }}
        />
      </div>
      <style>
        {`
          input[type="range"]::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: var(--slider-thumb-hover) !important;
            cursor: pointer;
            border: none;
            box-shadow: 0 0 15px var(--slider-thumb), 0 3px 12px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
          }
          
          input[type="range"]::-moz-range-thumb {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: var(--slider-thumb-hover) !important;
            cursor: pointer;
            border: none;
            box-shadow: 0 0 15px var(--slider-thumb), 0 3px 12px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
            -moz-appearance: none;
          }
        `}
      </style>
    </div>
  );
};
